import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Message } from "primeng/message";
import { NewUiInputtextComponent } from "../../../shared/form/inputtext/new-ui-inputtext.component";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ITranslationProposal } from "../translationProposal.model";

@Component({
  selector: "new-ui-translation-proposal-gathering",
  templateUrl: "./new-ui-translationProposalGathering.component.html",
  imports: [TranslateDirective, FormsModule, NewUiInputtextComponent, NewUiButton, Message],
})
export class NewUiTranslationProposalGatheringComponent {
  textToCorrect = null;
  textCorrected = null;
  reasonForCorrection = null;
  comment = null;

  constructor(
    @Inject(DynamicDialogConfig)
    private readonly config: DynamicDialogConfig,
    @Inject(DynamicDialogRef)
    private readonly dialog: DynamicDialogRef
  ) {
    this.textToCorrect = this.config.data.textToTranslate;
    this.textCorrected = this.textToCorrect;
  }

  cancel(_event: MouseEvent): void {
    this.dialog.close(null);
  }

  submit(_event: MouseEvent): void {
    this.dialog.close({
      textToCorrect: this.textToCorrect,
      translationProposal: this.textCorrected,
      reasonForCorrection: this.reasonForCorrection,
    } as ITranslationProposal);
  }
}
